import { render } from "./TrainModel.vue?vue&type=template&id=50f87fa0&scoped=true"
import script from "./TrainModel.vue?vue&type=script&lang=js"
export * from "./TrainModel.vue?vue&type=script&lang=js"

import "./TrainModel.vue?vue&type=style&index=0&id=50f87fa0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f87fa0"]])

export default __exports__